/**
 * @fileoverview Event Content View - UI for events in social post
 *
 * @author Chris Williams (cwilliams@yext.com)
 */
goog.module('yext.social.post.EventContentView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
const DateTimeInput = goog.require('yext.social.post.DateTimeInput');
const EventDialog = goog.require('yext.social.post.EventDialog');

/**
 * @constructor
 * @param {object<string, ?>} options
 */
const EventContentView = function(options) {
  this.eventDialog_ = new EventDialog(options['setEvent']);
  this.removeEvent_ = options['removeEvent'];
};

/**
 * @private
 * @param {object<string, ?>} event
 */
EventContentView.prototype.showDialog_ = function(event) {
  this.eventDialog_.show(event);
};

/**
 * @private
 * @param {boolean} disabled if adding events is disabled
 * @return {!jQuery} a new DOM node
 */
EventContentView.prototype.addEventDom_ = function(disabled) {
  var buttonClass = ['link', 'post-event', 'no-post-event'];
  var $button;
  if (disabled) {
    buttonClass.push('event-disabled');
    $button = $('<span>',
      {
        'class': buttonClass.join(' '),
        'data-content-element': '.event-tooltip',
        'text': yext.msg('+ Add Event'),
        'contextualHelp': {'location': 'right'},
      });
  } else {
    $button = $('<span>',
      {
        'class': buttonClass.join(' '),
        'click': function() {
          this.showDialog_();
        }.bind(this),
        'text': yext.msg('+ Add Event'),
      });
  }

  return [
    $button,
    $('<div>',
      {
        'class': 'event-tooltip',
        'style': 'display: none;',
        'append': yext.msg(
          'Adding an event is only available on Google Post. Select Google above to enable this.',
        ),
      }),
  ];
};

/**
 * @private
 * @param {object<string, ?>} event
 * @return {!jQuery} a new DOM node
 */
EventContentView.prototype.displayEventDom_ = function(event) {
  var startTime = event['startTime'];
  var endTime = event['endTime'];
  var options = {year: 'numeric', month: 'numeric', day: 'numeric'};
  var dateFormatter = new Intl.DateTimeFormat(navigator.language, options);
  var eventTime = yext.msg('Local Time ') +
      dateFormatter.format(startTime) +
      ', ' +
      DateTimeInput.formatTime(startTime);

  if (endTime) {
    eventTime += yext.msg(' to ') +
      dateFormatter.format(endTime) +
      ', ' +
      DateTimeInput.formatTime(endTime);
  }

  return [
    $('<div>',
      {
        'class': 'event-container',
        'append': [
          $('<span>',
            {
              'class': 'event-label',
              'text': yext.msg('Event'),
            }),
          $('<div>',
            {
              'class': 'event-data',
              'append': [
                $('<div>',
                  {
                    'class': 'event-title',
                    'text': event['title'],
                  }),
                $('<div>',
                  {
                    'class': 'event-time',
                    'text': eventTime,
                  }),
                $('<span>',
                  {
                    'class': 'modify-event',
                    'click': function() {
                      this.showDialog_(event);
                    }.bind(this),
                    'text': yext.msg('Modify'),
                  }),
              ],
            }),
          $('<div>',
            {
              'class': 'remove-event remove-item',
              'click': this.removeEvent_,
            }),
        ],
      }),
  ];
};

/**
 * @param {object<string, ?>} model
 * @return {!jQuery} a new DOM node
 */
EventContentView.prototype.render = function(model) {
  if (model['hidden']) {
    return $('');
  }

  var $content;
  if (!model['event']) {
    $content = this.addEventDom_(model['disabled']);
  } else {
    $content = this.displayEventDom_(model['event']);
  }

  return $('<div>',
    {
      'class': ['post-content-container-inner',
        'post-event-container',
        'js-post-event-container'].join(' '),
      'append': $content,
    });
};

exports = EventContentView;
